class VersionHistoryShowEvent extends Event {
  static name = "version-history.show";

  constructor() {
    super(VersionHistoryShowEvent.name, { bubbles: false });
  }

  send() {
    setTimeout(() => document.dispatchEvent(this));
  }
}

export default VersionHistoryShowEvent;
